import React from "react";
import "./Dialog.css";
import { useDispatch } from "react-redux";
import { updateDialogState } from "../../store/features/dialogStatesSlice";

interface DialogProps {
  title: string;
  content: string;
}

export default function Dialog({ title, content }: DialogProps) {
  const dispatch = useDispatch();

  const closeDialog = () => {
    dispatch(updateDialogState({ stateName: "isShowDialog", value: false }))
  }

  return (
    <div className="dbr-dialog" /* onClick={closeDialog} */>
      <div className="dbr-dialog-container" onClick={(e) => { e.stopPropagation() }}>
        <svg className="dbr-dialog-cancel-icon" onClick={closeDialog} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1498" width="15" height="15"><path d="M934.382936 824.346821c30.593785 30.650067 30.593785 80.31521-0.056282 110.965278-15.268752 15.325034-35.361369 22.989597-55.452963 22.989597-20.094664 0-40.187281-7.664563-55.512315-22.989597L510.214331 622.154819 197.066261 935.312098c-15.325034 15.325034-35.417651 22.989597-55.512315 22.989597-20.092617 0-40.184211-7.664563-55.452963-22.989597-30.650067-30.650067-30.650067-80.31521-0.056282-110.965278l313.177745-313.190025L86.044702 197.966771c-30.593785-30.650067-30.593785-80.31521 0.056282-110.965278 30.537504-30.652114 80.31521-30.652114 110.965278 0L510.214331 400.158772 823.361377 87.001493c30.650067-30.652114 80.427774-30.652114 110.965278 0 30.650067 30.650067 30.650067 80.31521 0.056282 110.965278L621.205191 511.156796 934.382936 824.346821z" fill="#272636" p-id="1499"></path></svg>
        <div className="dbr-dialog-title">{title}</div>
        <div className="dbr-dialog-content">{content}</div>
        <div className="dbr-learn-more">
          <a className="dbr-learn-more-btn" href="https://www.dynamsoft.com/panorama/batch-barcode-scanning/" rel="noreferrer" target="_blank" onClick={closeDialog}>LEARN MORE</a>
        </div>
      </div>
    </div>
  )
}